// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__SjC1_","validationTips":"StatementDescriptor_validationTips__1MVNN"};